module.exports = __webpack_public_path__ + "static/media/pirates.fe81630d.jpg";